import script from "./CallRecordingPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./CallRecordingPlayer.vue?vue&type=script&setup=true&lang=js"

import "./CallRecordingPlayer.vue?vue&type=style&index=0&id=3f69a824&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f69a824"]])

export default __exports__